import Cookies from 'js-cookie';
import {Inject, Injectable} from '@angular/core';
import { Observable, of, Subject } from 'rxjs';
import { BaseAuthService } from './base-auth.service';
import { AuthState } from '../model/AuthState';
import { RegisterProps } from '../model/RegisterProps';
import { IdpProvider } from '../model/IdpProvider';
import {LEGACY_CONFIGURATION, LegacyConfiguration} from "../config/legacy-configuration";

@Injectable()
export class LegacyAuthService implements BaseAuthService {
  authState: AuthState = {
    isAuthenticated: false
  }

  constructor(@Inject(LEGACY_CONFIGURATION) private config: LegacyConfiguration) {

  }

  hasOldToken(): boolean {
    const token = Cookies.get(this.config.tokenKeyName);
    return !!token;
  }

  async forgotPassword(email: string): Promise<void> {}

  async resetPassword(email: string, code: string, password: string): Promise<void> {}

  async logout(): Promise<void> {
    if (Cookies.get(this.config.tokenKeyName, { path: '/' })) {
      Cookies.remove(this.config.tokenKeyName, { path: '/' });
      Cookies.remove('customer_id');
    }
  }

  listenToStateChanges(): Observable<AuthState> {
    return new Subject<AuthState>();
  }

  isAuthenticated(): Observable<AuthState> {
    const token = Cookies.get(this.config.tokenKeyName);
    if (token) {
      return of({
        isAuthenticated: true
      });
    }
    return of({
      isAuthenticated: false
    });
  }

  getAccessToken(): Observable<string> {
    const token = Cookies.get(this.config.tokenKeyName);
    if (token) {
      return of(token);
    }
    return of('');
  }

  async authenticateFromExternalIdp(idpProvider: IdpProvider): Promise<void> {}

  async login(email: string, password: string): Promise<void> {}

  async changePassword(old_password: string, new_password: string): Promise<void> {}

  async changePasswordAsAdmin(new_password: string, user_id: number): Promise<void> {}

  async checkIfCognitoUserExist(): Promise<void> {}

  async register(props: RegisterProps): Promise<void> {}

  async getUserProfile(): Promise<any> {
    return null;
  }

  async updateEmail(data: any): Promise<any> {
    return null;
  }

  async verifyUpdateEmail(data: any): Promise<any> {
    return null;
  }
}
